<ion-content class="ion-bg-white">
  <div class="modal-container">
    <div class="img-container">
      <img *ngIf="img" [src]="img" [alt]="'Success'"/>
      <div *ngIf="!img" class="success-icon-circle">
        <ion-icon name="checkmark" class="success-icon-check"></ion-icon>
      </div>
    </div>
    <p class="fs-4 font500 ion-text-center text-color">
      {{ message }}
    </p>
  </div>
</ion-content>
